import React, {
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';

import './FeedBackLesson.css';

const FeedBackLesson = forwardRef(({ lessonId, chapterId, apiUrl, onFeedbackChange }, ref) => {
  const [difficulty, setDifficulty] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleDifficultyChange = (value) => {
    setDifficulty(value);
    onFeedbackChange?.(true);
  };

  const handleSubmit = async () => {
    if (!difficulty) return true;

    try {
      const response = await fetch(`${apiUrl}/feedback/lesson`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          lessonId,
          chapterId,
          rating: null,
          difficulty,
          message: '',
        }),
      });

      if (!response.ok) {
        throw new Error('Feedbackul nu a putut fi salvat');
      }

      setSubmitted(true);
      return true;
    } catch (err) {
      console.error('Eroare la trimiterea feedbackului:', err);
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    submitFeedback: handleSubmit,
    isSubmitted: () => submitted,
    hasFeedback: () => difficulty !== '',
  }));

  if (submitted) {
    return (
      <div className="feedback-lesson-card">
        <h3>Multumim pentru feedback! 💚</h3>
      </div>
    );
  }

  const options = [
    { value: 'prea usoara', label: '😎 prea usoara' },
    { value: 'potrivita', label: '😊 potrivita' },
    { value: 'prea dificila', label: '🤯 prea dificila' },
  ];

  return (
    <div className="feedback-lesson-card">
      <h3>Cat de dificila ti s-a parut lectia?</h3>

      <div className="feedback-difficulty feedback-difficulty-column">
        {options.map((item) => (
          <button
            key={item.value}
            type="button"
            className={difficulty === item.value ? 'active' : ''}
            onClick={() => handleDifficultyChange(item.value)}
          >
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default FeedBackLesson;